const gettersCart = {
  getOrderId: (state) => state.order_id,
  getInstallmentDefault: (state) => state.installment_default,
  getRecaptchaAttempts: (state) => state.recaptcha_attempts,
  getStoreName: (state) => state.store_name,
  getVisit: (state) => state.visit,
  getEnableAddress: (state) => state.enable_address,
  getFreights: (state) => state.freights,
  getHash: (state) => state.hash,
  getShopUrl: (state) => state.shop_url,
  getShopCancelUrl: (state) => state.shop_cancel_url,
  getStoreId: (state) => state.store_id,
  getDiscount: (state) => state.discount,
  getFreight: (state) => state.freights.find(({ id }) => id === state.freight),
  getTotal: (state) => state.total,
  getSubtotal: (state) => state.subtotal,
  getCoupon: (state) => state.coupon,
  getCouponId: (state) => state.coupon.id,
  getCouponCode: (state) => state.coupon.code,
  getOrderBumpRedirected: (state) => state.orderBumpRedirected,
  getItems: (state) => state.items,
  getBundles: (state) => state.items.bundles,
  totalRequestItems: (state) => state.items.bundles.length,
  getInstallments: (state) => state.installments,
  getFirstUpsell: (state) => {
    const { bundles } = state.items

    if (!bundles?.length && !bundles[0].upsells.length) {
      return null
    }
    return bundles[0].upsells[0]
  },
  getOrderBumps: () => {
    const { bundles } = JSON.parse(localStorage.getItem('items'))

    if (!bundles?.length || !bundles[0].order_bumps.length) {
      return null
    }
    const orderBumps = bundles[0]?.order_bumps[0]

    return orderBumps || null
  },
  getFreightId: (state) => state.freight_id,
  getUpsellHash: (state) => state.upsell_hash,
  getOrder: (state) => state.order,
  isInfoProduto: (state) => !state.enable_address,
  getPayment: (state) => state.payment,
  getCountryId: (state) => state.country_id,
  getCurrencyCode: (state) => state.currency_code,
  getTributes: (state) => state.tributes,
  getSelectedInstallment: (state) => state.selected_installment,
  getIsInternational: (state) => state.is_international,
  getEnableInternational: (state) => state.enable_international,
  isInternational: (state) => state.currency_code !== 'BRL',
  getSettings: (state) => state.settings,
  getStoreAllowCnpj: (state) => !!state.store_allow_cnpj,
  getHasApplePay: (state) => state.settings.payments.some((item) => item === 'applepay'),
}

export default gettersCart
